<div class="login trp-grid__row trp-flex--column">
	<div
		class="login__page trp-grid__column-4 trp-grid__column-t-6 trp-grid__column-d-6 trp-grid__offset-t-1 trp-grid__offset-d-3"
	>
		<header class="login__header trp-p--t-04 trp-p--b-03 trp-flex--row-vertical-center">
			<div class="login__logo-container trp-flex--column-center trp-p-01">
				<trp-image class="login__logo trp-flex--row" [src]="businessLogo"></trp-image>
			</div>
		</header>
		<main class="login__main">
			<div class="login__label trp__headline--large">
				{{ (hasIntegration$ | async) === false ? "Welcome to your Guest App" : "Sign in" }}
			</div>
			<div class="login__sub-label trp-text__body--small trp-m--t-02">
				{{
					(hasIntegration$ | async) === false
						? "Access your bookings from one place"
						: "Enter your email and password to log in"
				}}
			</div>
			<div class="login__form trp-flex--column trp-m--t-04" [formGroup]="loginForm">
				@if ((loginFormControls$ | async)?.length > 0) {
					@for (control of loginFormControls$ | async; track control) {
						<div class="login__form-field trp-flex--column">
							@if (control.field === "password") {
								<trp-password-input
									[formCtrl]="$any(loginForm.get(control.field))"
									[label]="control.label"
									[placeholder]="control.placeholder"
								></trp-password-input>
							} @else {
								<trp-input
									[formCtrl]="$any(loginForm.get(control.field))"
									[label]="control.label"
									[tooltip]="control.tooltip"
									[showLeadingIcon]="false"
									[type]="'text'"
									[placeholder]="control.placeholder"
								></trp-input>
							}
							@if (
								loginForm.get(control.field).invalid &&
								loginForm.get(control.field).touched &&
								loginForm.get(control.field).dirty
							) {
								<div class="trp-input__description trp-input__description--error">
									@if (loginForm.get(control.field).errors?.required) {
										<span>This field is required</span>
									}
								</div>
							}
						</div>
						@if (
							(formHasRoomAndReservation$ | async) === true &&
							(control.field === "tripId" || control.field === "reservationId")
						) {
							<div class="login__field-separator trp-p--t-02">
								<span
									class="login__field-separator-text trp-text__tag trp-flex--row-center"
									>Or</span
								>
							</div>
						}
					}
				}
				<trp-checkbox [control]="rememberMe" [label]="'Remember me'"></trp-checkbox>
			</div>
			<div class="login__action trp-m--t-04 trp-flex--column">
				<trp-button [expand]="true" (buttonClicked)="loginClicked()">Login</trp-button>
				<div class="login__terms trp-m--t-02 trp-p--y-01 trp-text__supporting">
					@if (terms || privacy) {
						By clicking Login, you acknowledge that you understand and agree to the
						@if (terms) {
							<span class="login__terms--underline" (click)="onTermsClick()"
								>Terms & Conditions</span
							>
							@if (privacy) {
								and
							}
						}
						@if (privacy) {
							<span class="login__terms--underline" (click)="onPrivacyClick()"
								>Privacy Policy</span
							>
						}
					}
				</div>
			</div>
		</main>
		<footer class="login__footer trp-p--b-05 trp-flex--column-center">
			<trp-powered></trp-powered>
		</footer>
	</div>
</div>

@if (terms) {
	<div trpDialog #termsDialog="trpDialog" [title]="'Terms & Conditions'">
		<p [innerHTML]="terms | safe: 'html'"></p>
	</div>
}

@if (privacy) {
	<div trpDialog #privacyDialog="trpDialog" [title]="'Privacy Policy'">
		<p [innerHTML]="privacy | safe: 'html'"></p>
	</div>
}
